"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateLeverageModalComponent = exports.UpdateLeverageModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Modal = _interopRequireDefault(require("../../../common/Modal/Modal"));
var _Slider = require("../../../common/Slider/Slider");
var _Spinner = _interopRequireDefault(require("../../../common/Spinner/Spinner"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _modalActions = require("../../../../redux/actions/modalActions");
var _modalDecorator = _interopRequireDefault(require("../../../../hocs/modalDecorator"));
var _useLeverageDialog2 = require("./useLeverageDialog");
require("./UpdateLeverageModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('setup-leverage-modal');
var UpdateLeverageModalComponent = exports.UpdateLeverageModalComponent = function UpdateLeverageModalComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var isOpen = props.isOpen,
    close = props.close,
    formName = props.formName;
  var _useLeverageDialog = (0, _useLeverageDialog2.useLeverageDialog)(formName),
    isBuy = _useLeverageDialog.isBuy,
    onConfirm = _useLeverageDialog.onConfirm,
    onCancel = _useLeverageDialog.onCancel,
    max = _useLeverageDialog.max,
    sliderValue = _useLeverageDialog.sliderValue,
    setSliderValue = _useLeverageDialog.setSliderValue,
    breakpoints = _useLeverageDialog.breakpoints;
  var showBreakPoints = max > 10 ? false : true;
  var buyOrSell = isBuy ? t('Buy') : t('Sell');
  var handleCancel = function handleCancel() {
    onCancel();
    close();
  };
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t('Cross Margin Leverage'),
    close: close,
    onCancel: handleCancel,
    footer: {
      buttonText: t('Confirm'),
      buttonStyle: 'buy__btn',
      onClick: onConfirm
    },
    customClass: bemClasses('buy')
  }, max ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Slider.Slider, {
    disabled: false,
    onChange: setSliderValue,
    value: sliderValue,
    step: 1,
    breakpoints: breakpoints,
    formatOutput: function formatOutput(value) {
      return "".concat(value, "x");
    },
    showBreakPoints: showBreakPoints,
    hideLabels: false
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: bemClasses('message')
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    ns: "margin"
  }, "After the adjustment, your ", /*#__PURE__*/_react["default"].createElement("strong", null, "Max ", {
    buyOrSell: buyOrSell
  }, " Amount"), " will change accordingly."))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "slider-loading"
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)));
};
var UpdateLeverageModal = exports.UpdateLeverageModal = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.UPDATE_LEVERAGE
})(UpdateLeverageModalComponent);